import React from 'react'
import { useNavigate } from "react-router";
import { getStateLoaded, setReportData, setReportName, setStateLoaded } from "../../store/store";
import { loadReport } from 'helpers/loadReport';

export default function Home() {
	var loaded = getStateLoaded();
	console.log("Home: ", loaded);

	let navigate = useNavigate();
	setReportName('');

	async function openFile() {
		var options = {
			types: [
				{
					description: 'XML Files',
					accept: {
						'text/xml': ['.xml'],
					}
				},
			],
			excludeAcceptAllOption: true,
			multiple: false,
			mode: "read",
			startIn: "downloads",
		}

		try {
			const [handle] = await window.showOpenFilePicker();
			//console.log("handle: ",handle);
			const filename = handle.name;
			//console.log("filename: ", filename);
			const file = await handle.getFile();
			//console.log("file: ", file);
			const data = await file.text(file);
			//console.log("data: ",data.length);

			if (!data.includes("<RESPONSE_GROUP ")) {
				alert("File is not a MISMO XML");
				return;
			}

			setReportName(filename);
			setReportData(data);
			loadReport();
			setStateLoaded(true);
			console.log("navigate to report")
			navigate( '/reports');
		} catch (error) {
				console.log("showOpenFilePicker", error);
				alert(error);
			return;
		}
	}

	return (
		<div className="mt-[72px] flex flex-col justify-center">
				<div className="text-center text-xl font-semibold pt-10">
					This program displays a MISMO Version 2.3.1 XML Credit Report
					<br />
					<br />
					Use the button below to select the XML file to view.
				</div>
				<div className="flex justify-center font-semibold pt-6">
					<button className="bg-gray-300 rounded-md p-2 hover:cursor-pointer" onClick={() => openFile()} >Select MISMO XML Credit Report File</button>
				</div>
				<div className="w-full pt-10 flex flex-row justify-center">
					<p className='w-10/12 text-xl font-semibold'>
						<b>Note: </b>This application is a Progressive Web Application (PWA). A PWA runs completely
						on the client side. No data is ever sent to the server. Also, a PWA can be installed as an application
						and run without an internet connection.
						<br /><br />
						To install, look for the install icon in the URL bar of the browser and click on it.
					</p>
				</div>
				<div className='w-full flex justify-center pt-10'>
					<img src={require('images/app-install.png')} />
				</div>
		</div>
	);
}

